import { ProfileIcon } from "./icon.utils";
import { getItem, removeItem, setItem } from "./localStorage.utils";

export const navbarToggleName = "navToggle";

export function getNavToggle() {
  return getItem(navbarToggleName) === "true";
}

export function setNavToggle() {
  return setItem(navbarToggleName, true);
}

export function removeNavToggle() {
  return removeItem(navbarToggleName);
}

export const profileDropdowns = [
  {
    name: "Profile",
    icon: ProfileIcon,
    link: "/profile"
  }
];

export function getAllProfileDropdown() {
  return profileDropdowns;
}
